import { render, staticRenderFns } from "./upgradeList.vue?vue&type=template&id=aa81c358&scoped=true&"
import script from "./upgradeList.vue?vue&type=script&lang=js&"
export * from "./upgradeList.vue?vue&type=script&lang=js&"
import style0 from "./upgradeList.vue?vue&type=style&index=0&id=aa81c358&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa81c358",
  null
  
)

export default component.exports